module.exports = __webpack_public_path__ + "static/media/icon-arrow-down-red.cde11ae2.svg";